export default __webpack_public_path__ + "static/media/icon-plug.475ff40c.svg";